import defaultApi from '@/utils/request';

export default {
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_LectureLesson/Load',
      params,
    });
  },
  Get(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_LectureLesson/Get',
      params,
    });
  },
  Add(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_LectureLesson/Add',
      data,
    });
  },
  Update(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_LectureLesson/Update',
      data,
    });
  },
  Delete(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_LectureLesson/Delete',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data,
    });
  },
  SelectData(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_category/SelectData',
      params,
    });
  },
};
